class OverlayAccessibility {
    constructor() {
        this.observer = new MutationObserver(() => this.processOverlay());
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.observer.observe(document.body,
                {
                    childList: true,
                    subtree: true
                });
        });
    }

    processOverlay() {
        const overlay = document.querySelector('.fancybox-overlay');
        if(!overlay) {
            return;
        }

        this.ensureOverlayWrapped(overlay);
        this.ensureOverlayAccessibility(overlay);
    }

    ensureOverlayWrapped(overlay) {
        if(overlay.dataset.a11y) {
            return;
        }
        this.removeOldAsides();
        this.wrapInAside(overlay);
        overlay.dataset.a11y = 'true';
    }

    ensureOverlayAccessibility(overlay) {
        const overlayInner = overlay.querySelector('.fancybox-inner');
        if(!overlayInner || overlayInner.dataset.a11y) {
            return;
        }

        const focusables = overlay.querySelectorAll('a[href]:not([disabled]), button:not([disabled])');
        if(!focusables.length) {
            return;
        }

        this.trapFocus(overlay);
        this.addAltToOverlayImage();
        overlayInner.dataset.a11y = 'true';
    }

    wrapInAside(element) {
        const landmark = document.createElement('aside');
        element.parentElement.insertBefore(landmark, element);
        landmark.appendChild(element);
    }

    removeOldAsides() {
        const asides = document.querySelectorAll('aside');
        asides.forEach(aside => {
            if(aside.innerHTML === '') {
                aside.remove();
            }
        });
    }

    trapFocus(container) {
        const selector = 'a[href]:not([disabled]), button:not([disabled])';
        const focusables = container.querySelectorAll(selector);
        if(!focusables.length) {
            return;
        }

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        first.addEventListener('keydown', (e) =>
            this.handleTabLock(e,
                {
                    backward: true,
                    target: last
                })
        );
        last.addEventListener('keydown', (e) =>
            this.handleTabLock(e,
                {
                    forward: true,
                    target: first
                })
        );

        first.focus();
    }

    handleTabLock(e, {
        forward = false,
        backward = false,
        target
    }) {
        if(e.key !== 'Tab') {
            return;
        }

        if(backward && e.shiftKey) {
            e.preventDefault();
            target.focus();
        }

        if(forward && !e.shiftKey) {
            e.preventDefault();
            target.focus();
        }
    }

    addAltToOverlayImage() {
        const title = document.querySelector('.fancybox-title');
        const image = document.querySelector('.fancybox-image');
        if(title && image) {
            image.alt = title.textContent || '';
        }
    }

    disconnect() {
        this.observer.disconnect();
    }
}
